
























































































import { Vue, Component, Emit, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { dictServe, doublePrevention, institutionServer, performanceServer } from '@/api/installServer';
import { arrayToTree } from '@/util/array';
import publicProp from '@/views/teamManagementTeam/publicProp.vue';

@Component({
  components: { PagingUnit, CollapseTransition, publicProp },
  mixins: [TableStripe],
})
export default class RiskControlList extends Vue {
  private searchForm: any = {
    level: '', // 应急队伍级别
    type: '', // 应急队伍类型
    peopleName: '', // 负责人 -> search
    deptId: '', // 单位
  };
  foundDate: any = []; // 成立日期
  levelList: any = [
    {
      label: '国家级',
    },
    {
      label: '省级',
    },
    {
      label: '州级',
    },
    {
      label: '地市级',
    },
    {
      label: '区县级',
    },
    {
      label: '乡镇级',
    },
    {
      label: '其他',
    },
  ]; // 应急队伍级别
  typeList: any = []; // 应急队伍类型
  private tableLoading = false; // loading...
  private tableData: any = [];
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0;
  subSpaceByAuthOptions: any = []; // 单位

  private formShow = true; // 是否显示搜索表单内容
  isShowForm() {
    this.formShow = !this.formShow;
  }

  // 点击按钮跳到相同的弹窗
  private jumpToPublicProp(type: any, data: any) {
    const passValue: any = {
      type: type,
      data: data,
    };
    if (type === 'delete') {
      this.$confirm('此操作将永久删除当前数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          doublePrevention.deleteEmergencyContingent(data.id).then((res: any) => {
            if (res.code === '200') {
              this.$message.success('删除成功！');
              this.getTableData();
            } else {
              this.$message.warning('网络错误，请稍后再试！');
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    } else {
      (this.$refs.publicProp as any).showDialog(passValue);
    }
  }

  private onSearch() {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private onReset() {
    this.foundDate = [];
    this.searchForm = {
      levelList: '',
      peopleName: '',
    };
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private getListData() {
    this.getTableData();
  }

  private getTableData() {
    this.tableLoading = true;
    doublePrevention
      .getEmergencyContingent({
        // ...this.queryDataForm,
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        level: this.searchForm.level ? this.searchForm.level : null,
        type: this.searchForm.type ? this.searchForm.type : null,
        search: this.searchForm.peopleName ? this.searchForm.peopleName : null,
        setUpDateByStart: this.foundDate && this.foundDate.length ? this.foundDate[0] : null,
        setUpDateByEnd: this.foundDate && this.foundDate.length ? this.foundDate[1] : null,
        deptId: this.searchForm.deptId || null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.queryDataForm.pageSize = res.data.size;
        } else {
          this.$message.warning('获取队伍表格的数据失败！');
        }
      });
  }

  // 应急队伍类型 的下拉
  getTypeList() {
    dictServe.getDetailsMapByName('emergencyContingentType').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        this.typeList = helpArr;
      } else {
        this.$message.warning('获取应急队伍类型下拉数据失败！');
      }
    });
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  created() {
    this.getTableData();
    this.getSubSpaceByAuth();
    this.getTypeList();
  }
}
